import { render, staticRenderFns } from "./LegacyView.vue?vue&type=template&id=6ceb865b&scoped=true&"
import script from "./LegacyView.vue?vue&type=script&lang=js&"
export * from "./LegacyView.vue?vue&type=script&lang=js&"
import style0 from "./LegacyView.vue?vue&type=style&index=0&id=6ceb865b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb865b",
  null
  
)

export default component.exports